import React from "react";
import PropTypes from "prop-types";
import Toolbar from "./Toolbar";
import Mapa from "../Mapa";
import Alert from "../common/Alert";
import Buscador from "./Buscador";
import IntroJS from "../common/IntroJS";
import { Event } from "../../helpers/event-helper";
import LonLat from "./LonLat";
/**
 * Visor de parcelas
 */
export default class Visor extends React.Component {
  /**
   * Referencia al visor de datos cartográficos
   */
  visor = React.createRef();

  /**
   * Referencia al alert
   */
  alert = React.createRef();

  /**
   * Referencia al modal de búsqueda.
   */
  buscador = React.createRef();

  /**
   * Referencia al modal de búsqueda por coordenadas.
   */
  lonlat = React.createRef();
  /**
   * Se encarga de manejar los eventos del toolbar.
   * @param {string} event
   */
  on(event) {
    switch (event) {
      case "buscar":
        this.lonLat.setState({ expanded: false });
        this.buscador.open();
        break;
      case "ayuda":
        this.startIntro();
        break;
      case "informacion":
        this.informacion();
        break;
      case "ubicacion":
        this.ubicacion();
        break;
      case "lonlat":
        this.buscador.setState({ expanded: false });
        this.lonLat.open();
        break;
      case "geolocalizacion":
        this.geolocalizacion();
        break;
      default:
        break;
    }
  }
  /**
   * Se encarga de iniciar la ayuda
   */
  startIntro() {
    this.intro.show();
  }

  geolocalizacion() {
    Event.publish(Event.VISOR_CURRENT_LOCATION);
  }

  /**
   * Se encarga de inicializar el control de información del mapa.
   */
  informacion() {
    Event.publish(Event.VISOR_FEATURE_INFO);
  }

  /**
   * Se encarga de inicializar el control de información del mapa.
   */
  ubicacion() {
    Event.publish(Event.VISOR_CLICK_INFO);
  }

  /**
   * Se encarga de manejar el evento buscar del formulario
   * de busqueda, este metodo propaga el evento `VISOR_BUSQUEDA`.
   */
  onSearch(data) {
    setTimeout(() => {
      Event.publish(Event.VISOR_BUSQUEDA, data);
    }, 500);
  }

  /**
   * Se encarga de manejar el evento ubicar del formulario
   * de busqueda por coordenadas, este metodo propaga el evento `VISOR_LONLAT`.
   */
  onLonlat(data) {
    setTimeout(() => {
      Event.publish(Event.VISOR_LONLAT, data);
    }, 500);
  }

  onExit() {
    this.buscador.setState({ expanded: false });
  }

  stepChange(index, step) {
    //if(index == 0){
    this.buscador.setState({ expanded: true, index: index });
    //}
  }

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    return (
      <React.Fragment>
        <Alert onRef={ref => (this.alert = ref)} />
        <IntroJS
          onRef={ref => (this.intro = ref)}
          onHide={evt => this.onExit()}
          onChange={(i, s) => this.stepChange(i, s)}
        />
        <section className="columns">
          <Toolbar on={evt => this.on(evt)} />
          <Buscador
            onRef={ref => (this.buscador = ref)}
            onSearch={d => this.onSearch(d)}
          />
          <LonLat
            onRef={ref => (this.lonLat = ref)}
            onSearch={d => this.onLonlat(d)}
          />
          <div className="column no-padding">
            <Mapa
              onRef={ref => (this.visor = ref)}
              onSearch={d => this.onSearch(d)}
            />
          </div>
        </section>
      </React.Fragment>
    );
  }
}
